import { Button as AntButton } from 'antd';
import styled from 'styled-components';

export const Button = styled(AntButton)`
  transition: all 0.3ms ease;
  svg {
    opacity: 0.5;
  }

  &:hover {
    svg {
      opacity: 1;
    }
  }
`;
